<template>
  <div class="npc-behavior-selector">
    <label>Starting Behavior</label>
    <md-field>
      <md-select
        placeholder="Select Starting Behavior"
        aria-label="Select Starting Behavior"
        data-testid="select-starting-behavior-button"
        :value="behaviorValue"
        :disabled="readonly || !position"
        :readonly="readonly || !position"
        @input="updateBehavior"
      >
        <md-option
          v-for="option in behaviorOptions"
          :key="option.key"
          :value="option.key"
          :aria-label="option.label + ' behavior'"
          :data-testid="'behavior-option-' + option.key.toLowerCase()"
        >
          {{ option.label }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
import states from '~lib/common/config/states';

const npcAnimationState = states.find(s => s.id === 'npcAnimation');

export default {
  name: 'npc-behavior-selector',
  props: {
    behavior: {
      type: String,
      default: null,
    },
    position: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    behaviorValue() {
      return this.behavior || npcAnimationState.defaultValue;
    },
    behaviorOptions() {
      return npcAnimationState.possibleValues
        .filter(v =>
          v.meta &&
          v.meta.isRepeating &&
          (!this.position || v.meta.compatiblePositions.includes(this.position))
        )
        .map(v => ({ key: v.key, label: v.label.en }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  methods: {
    updateBehavior(value) {
      if (!value) return;
      this.$emit('update', value);
    },
  },
};
</script>

<style scoped>
.npc-behavior-selector {
  width: 100%;
  margin-right: 10px;
}
</style>
